import React, { useState, useEffect } from 'react';
import { FileText, AlertCircle } from 'lucide-react';
import '../../styles/components.css';

const UserManual = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);

  useEffect(() => {
    loadUserManual();
  }, []);

  const loadUserManual = async () => {
    try {
      setLoading(true);
      setError(null);
      
      // Construct the URL for the user manual PDF endpoint
      const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/api/v1/user-manual/document`;
      
      setPdfUrl(apiUrl);
      setLoading(false);
    } catch (err) {
      console.error('Error loading user manual:', err);
      setError('Failed to load user manual. Please try again later.');
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="page-container">
        <div className="page-header">
          <div className="page-header-content">
            <div className="page-title-section">
              <FileText className="page-icon" size={32} />
              <h1 className="page-title">User Manual</h1>
            </div>
          </div>
        </div>
        
        <div className="page-content">
          <div className="card" style={{ padding: '3rem', textAlign: 'center' }}>
            <div className="loading-spinner loading-spinner-lg"></div>
            <p style={{ marginTop: '1rem', color: 'var(--text-secondary)' }}>
              Loading user manual...
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page-container">
        <div className="page-header">
          <div className="page-header-content">
            <div className="page-title-section">
              <FileText className="page-icon" size={32} />
              <h1 className="page-title">User Manual</h1>
            </div>
          </div>
        </div>
        
        <div className="page-content">
          <div className="card" style={{ padding: '2rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', color: 'var(--danger)' }}>
              <AlertCircle size={24} />
              <div>
                <h3 style={{ margin: 0, marginBottom: '0.5rem' }}>Error Loading Document</h3>
                <p style={{ margin: 0, color: 'var(--text-secondary)' }}>{error}</p>
              </div>
            </div>
            <button 
              className="btn btn-primary" 
              onClick={loadUserManual}
              style={{ marginTop: '1.5rem' }}
            >
              Try Again
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container" style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <div className="page-header" style={{ flexShrink: 0 }}>
        <div className="page-header-content">
          <div className="page-title-section">
            <h1 className="page-title">All American Asphalt LCA Application User Manual</h1>
          </div>
        </div>
      </div>
      
      <div className="page-content" style={{ flex: 1, display: 'flex', flexDirection: 'column', padding: 0 }}>
        <div className="card" style={{ 
          flex: 1, 
          display: 'flex', 
          flexDirection: 'column',
          padding: 0,
          margin: '1rem',
          overflow: 'hidden',
          backgroundColor: '#525659'
        }}>
          <iframe
            src={pdfUrl}
            style={{
              width: '100%',
              height: '100%',
              border: 'none',
              borderRadius: 'inherit'
            }}
            title="User Manual PDF"
            type="application/pdf"
          />
        </div>
      </div>
    </div>
  );
};

export default UserManual;